import styled from 'styled-components';

const StyledCustomLabelTextWrapper = styled.div`
  color: ${props => props?.$styles?.labelColor || '#595656'};
  font-size: ${props => props?.$styles?.labelFontSize || '12px'};
  font-weight: ${props => props?.$styles?.labelFontWeight || '500'};
`;

export default StyledCustomLabelTextWrapper;
